import { fetchLocationById } from '@components/common/search/helpers/search';

export default async function getProvinceLocationFromTown({
  location,
  setQueryBuilderStateFromPanel,
}) {
  if (!location) return;

  const parentId = location?.parent?.province?.id;
  if (!parentId) return;

  const removeGeoShapes = true; // to avoid fetching heavy geo shapes that are not needed in the QB state
  const newParentLocation = await fetchLocationById(parentId, removeGeoShapes);

  setQueryBuilderStateFromPanel({
    locations: [location],
    parentLocation: newParentLocation,
  });

  return newParentLocation;
}
